export const HEAT_COLOR = {
  DEFAULT: "#a5a7b2",
  LEVEL_1: "#1bcb11",
  LEVEL_2: "#bbff00",
  LEVEL_3: "#ddff00",
  LEVEL_4: "#eeff00",
  LEVEL_5: "#ffdd00",
  LEVEL_6: "#ffaa00",
  LEVEL_7: "#ff7700",
  LEVEL_8: "#ff5500",
  LEVEL_9: "#ff3300",
  LEVEL_10: "#ff0000"
};

export const getVisibilityLevelData = (
  intensity,
  defaultColor = HEAT_COLOR.DEFAULT
) => {
  const visibility = [
    { intensity: 0, color: defaultColor, label: "20+" },
    { intensity: 0.05, color: HEAT_COLOR.LEVEL_10, label: "20" },
    { intensity: 0.1, color: HEAT_COLOR.LEVEL_9, label: "19" },
    { intensity: 0.15, color: HEAT_COLOR.LEVEL_9, label: "18" },
    { intensity: 0.2, color: HEAT_COLOR.LEVEL_8, label: "17" },
    { intensity: 0.25, color: HEAT_COLOR.LEVEL_8, label: "16" },
    { intensity: 0.3, color: HEAT_COLOR.LEVEL_7, label: "15" },
    { intensity: 0.35, color: HEAT_COLOR.LEVEL_7, label: "14" },
    { intensity: 0.4, color: HEAT_COLOR.LEVEL_6, label: "13" },
    { intensity: 0.45, color: HEAT_COLOR.LEVEL_6, label: "12" },
    { intensity: 0.5, color: HEAT_COLOR.LEVEL_5, label: "11" },
    { intensity: 0.55, color: HEAT_COLOR.LEVEL_5, label: "10" },
    { intensity: 0.6, color: HEAT_COLOR.LEVEL_4, label: "9" },
    { intensity: 0.65, color: HEAT_COLOR.LEVEL_4, label: "8" },
    { intensity: 0.7, color: HEAT_COLOR.LEVEL_3, label: "7" },
    { intensity: 0.75, color: HEAT_COLOR.LEVEL_3, label: "6" },
    { intensity: 0.8, color: HEAT_COLOR.LEVEL_2, label: "5" },
    { intensity: 0.85, color: HEAT_COLOR.LEVEL_2, label: "4" },
    { intensity: 0.9, color: HEAT_COLOR.LEVEL_1, label: "3" },
    { intensity: 0.95, color: HEAT_COLOR.LEVEL_1, label: "2" },
    { intensity: 1, color: HEAT_COLOR.LEVEL_1, label: "1" }
  ];

  return visibility.find(
    (color, index) =>
      intensity === visibility[index].intensity ||
      (intensity > visibility[index].intensity &&
        intensity < visibility[index + 1].intensity)
  );
};
